var path = 'event/event-header-stats.tpl.html';
var html = "\n<div translate class=\"tb-cell\" flex>event.event-time</div>\n<div translate class=\"tb-cell\" flex>event.server</div>\n<div translate class=\"tb-cell tb-number\" flex>event.messages-processed</div>\n<div translate class=\"tb-cell tb-number\" flex>event.errors-occurred</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/event/event-header-stats.tpl.html
// module id = 1483
// module chunks = 1